import {postfile, qspost,upload} from '@/plugins/axios'
import {FILE_UPLOAD_HOST, FW_NLINEHOST} from "@/config";

/***
 * ---------------------------------------------------------- 项目申报 ----------------------------------------------------------
 */


/*
 * 添加项目
 * */
export const addApplyPro = (p_name,type= 0) => qspost('/api/project_ex/addPro', {p_name,type})

/*
 * 关联项目
 * */
export const relevancyApplyPro = (p_id,p_name,type= 0) => qspost('/api/project_ex/addPro', {p_id,p_name,type})

/*
 * 提交审核项目
 * */
export const submitApplyPro = (p_id,type= 1) => qspost('/api/project_ex/addPro', {p_id,type})

/*
 * 关联项目列表
 * */
export const getRelevancyProjectList = (keyword, p_mid,join_mid,page,limit) => qspost('/api/project_ex/ProList', {keyword, p_mid,join_mid,page,limit})

/*
 * 项目申请列表
 * */
export const getApplyProjectList = (keyword, p_mid,join_mid,page,limit) => qspost('/api/project_ex/index', {keyword, p_mid,join_mid,page,limit})

/*
 * 项目详情
 * */
export const getApplyProjectDetail = (p_id) => qspost('/api/project_ex/proInfo', {p_id})

/*
 * 通知列表
 * */
export const getProjectJoinNoticeFiles = (pid) => qspost('/api/Statistics/memberFileList', {pid})

/*
 * 新增参与人员文件
 * 0文件1文件夹
 * */
export const addJoinNoticeFile = (pid,parent_id,type,path,name,file,id = 0) => qspost('/api/Statistics/addMemberFile', {pid,parent_id,type,path,name,file,id})

/*
 * 新增参与人员文件
 * 0文件1文件夹
 * */
export const uploadJoinNoticeFile = (params) => upload('/api/Statistics/addMemberFile', params)

/*
 * 删除参与人员文件
 * */
export const delJoinNoticeFile = (id) => qspost('/api/Statistics/delMemberFile', {id})



/*
 * 参与人员列表（文件夹时间正序，文件首字母）
 * */
export const getApplyProjectNoticeFiles = (p_id) => qspost('/api/project_ex/noticeList', {p_id})


/*
 * 申报信息（1）添加通知文件
 * 0文件1文件夹
 * */
export const addNoticeFile = (p_id,parent_id,type,path,name,id = 0) => qspost('/api/project_ex/addNotice', {p_id,parent_id,type,path,name,id})


/*
 * 申报信息（1）删除通知文件
 * */
export const delNoticeFile = (id) => qspost('/api/project_ex/delNotice', {id})


/*
 * 项目申请项目基本信息
 * */
export const addApplyProjectBasic = (p_id,p_name,p_code,cate,client, client_contact, client_phone, undertaker, p_mid, pm_phone,
                                start_time, end_time, ex_money,join_mid_str
) => qspost('/api/project_ex/addDetail', {p_id,p_name,p_code,cate,client, client_contact, client_phone, undertaker, p_mid, pm_phone,
    start_time, end_time, ex_money,join_mid_str})

/*
 *审核项目申请
 * status	1是		-1未通过2通过
 * step	1是		步骤1项目申报2申报材料
 * */
export const applyProject = (p_id,status,remark,step = 1) => qspost('/api/admin_project_ex/shenhe', {p_id,status,remark,step})


/*
 *模板列表（申报书）
 * 1主申报书2辅助申报材料
 * */
export const getApplyModelList = (p_id,type,keyword) => qspost('/api/project_ex/getModelList', {p_id,type,keyword})

/*
 *获取申报书（列表）
 * 1主申报书2辅助申报材料
 * */
export const getApplyProjectDeclaration = (p_id,type) => qspost('/api/project_ex/getExFile', {p_id,type})

/*
 *编写申报书
 * 1主申报书2辅助申报材料
 * is_shen： 1 审核
 * */
export const addApplyProjectDeclaration = (id,p_id,type,title,content,file_path,is_shen = 0) => qspost('/api/project_ex/addExFile', {id,p_id,type,title,content,file_path,is_shen})



/***
 * ----------------------------------------------------------项目进行中----------------------------------------------------------
 */
/*
 * 项目列表
 * */
export const getProjectList = (keyword, client, undertaker, p_mid,sort,start_sort,status_sort,status,start_time,end_time,
                               page,limit) => qspost('/api/Project/getProjectList', {
                                   keyword, client, undertaker, p_mid,sort,start_sort,status_sort,status,start_time,end_time,page,limit})

/*
 * 审核人获取项目列表
 * */
export const getProjectExList = (keyword, client, undertaker, p_mid,page,limit) => qspost('/api/Project/getProjectExList', {keyword, client, undertaker, p_mid,page,limit})

/*
 * 项目数据汇总
 * */

export const getProjectTotal = () => qspost('api/Project/getProjectTotal', {})

/*
 * 删除项目（最高权限真删除）
 * */
export const delProject = (id) => qspost('/api/Project/delProject', {id})

/*
 * 项目详情
 * */
export const getProjectDetail = (id) => qspost('/api/Project/getProjectDetail', {id})

/*
 * 获取该机构所有成员列表
 * */
export const getAllMember = () => qspost('/api/Project/getAllMember', {})

/*
 * 新增项目基本信息
 * */
export const addProjectBasic = (id,p_name,p_code,cate,client, client_contact, client_phone, undertaker, p_mid, pm_phone,
                                start_time, end_time, p_money,invoice_name,invoice_code,invoice_money,invoice_time,get_invoice_time,invoice_file
) => qspost('/api/Project/addProject', {id,p_name,p_code,cate,client, client_contact, client_phone, undertaker, p_mid, pm_phone,
    start_time, end_time, p_money,invoice_name,invoice_code,invoice_money,invoice_time,get_invoice_time,invoice_file})


/*
 * 获取项目文件夹
 * */
export const getProjectFolder = (id) => qspost('/api/Project/getProjectFolder', {id})

/*
 * 创建/更新项目附件文件夹
 * */
export const addProjectFolder = (pid,id,parent_id,name) => qspost('/api/Project/addProjectFolder', {pid,id,parent_id,name})

/*
 * 删除项目文件夹
 * */
export const delProjectFolder = (id) => qspost('/api/Project/delProjectFolder', {id})

/*
 * 上传项目附件到文件夹
 * */
export const addProjectFolderFile = (pid,wid,file_url,file_name) => qspost('/api/Project/addProjectFolderFile', {pid,wid,file_url,file_name})

/*
 * 删除项目文件
 * */
export const delProjectFolderFile = (id) => qspost('/api/Project/delProjectFolderFile', {id})

/*
 * 根据文件ID获取文件信息
 * */

export const getEnclosureById = (id,type) => qspost('api/Project/getEnclosureById', {id,type})

/*
 * 修改文件名称
 * */

export const reSetFileName = (id,name,type) => qspost('api/Project/reSetFileName', {id,name,type})


/*
 * 判断用户下载权限及项目成员状态及项目文件总数
 * */

export const getDownloadByMid = (pid) => qspost('api/Member/getDownloadByMid', {pid})

/*
 * 查询下载权限人员
 * */

export const getDownloadPower = (pid) => qspost('api/Project/getDownloadPower', {pid})

/*
 * 添加修改权限
 * */

export const saveDownloadPower = (pid,downloadPower) => qspost('api/Project/saveDownloadPower', {pid,downloadPower})

/*
 * 新增项目发票
 * */
export const addProjectInvoice = (id,invoice_name,invoice_code,invoice_money,invoice_time,get_invoice_time,invoice_file
) => qspost('/api/Project/addProject', {id,invoice_name,invoice_code,invoice_money,invoice_time,get_invoice_time,invoice_file})

/*
 * 获取项目成员列表
 * */
export const getProjectMember = (pid) => qspost('/api/Createtask/getProjectMember', {pid})

/*
 * 更新项目参与成员
 * */
export const updateProjectJoinMember = (id,join_mid_str) => qspost('/api/Project/updateProjectJoinMember', {id,join_mid_str})

/*
 * 获取项目状态
 * */
export const getProjectStatus = (pid) => qspost('/api/Createtask/getProjectStatus', {pid})

/*
 * 获取任务阶段列表
 * */
export const getTopTaskList = (pid) => qspost('/api/Createtask/getTopTaskList', {pid})

/*
 * 获取任务列表
 * */
export const getTaskList = (id) => qspost('/api/Createtask/getTaskList', {id})

/*
 * 删除任务阶段
 * */
export const delTaskTarget = (id) => qspost('/api/Task/delTaskTarget', {id})

/*
 * 任务详情
 * */
export const getTaskDetail = (id) => qspost('/api/Createtask/getTaskDetail', {id})

/*
 * 提交赋分审核前的添加/编辑任务阶段
 * */
export const addTaskStage = (proid,id,name,t_mid,end_time) => qspost('/api/Createtask/addTaskStage', {proid,id,name,t_mid,end_time})

/*
 * 排序
 * */
export const taskOrder = (id) => qspost('/api/Createtask/taskOrder', {id})

/*
 * 删除
 * */
export const delTask = (id) => qspost('/api/Createtask/delTask', {id})

/*
 * 赋分审核后的添加阶段
 * */
export const addOutTaskStage = (proid,id,name,t_mid,end_time) => qspost('/api/Task/addTaskStage', {proid,id,name,t_mid,end_time})

/*
 * 提交赋分审核前的添加/编辑任务
 * */
export const addTaskTarget = (proid,pid,id,name,level,t_mid,join_mid_str,end_time,desc,recommend
                             ,file,folder_ids) => qspost('/api/Createtask/addTaskTarget', {proid,pid,id,name,level,t_mid,join_mid_str,end_time,desc,recommend,file,folder_ids})

/*
 * 赋分审核后的的添加/编辑任务
 * */
export const addOutTaskTarget = (proid,pid,name,level,t_mid,join_mid_str,end_time,desc,recommend
                             ,file,folder_ids) => qspost('/api/Task/addTaskTarget', {proid,pid,name,level,t_mid,join_mid_str,end_time,desc,recommend,file,folder_ids})

/*
 * 提交任务修改审核
 * */
export const updateTaskEx = (proid,pid,id,name,level,t_mid,join_mid_str,end_time,desc,recommend
                             ,file,folder_ids,is_change,ex_reason) => qspost('/api/Task/updateTaskEx', {proid,pid,id,name,level,t_mid,join_mid_str,end_time,desc,recommend
    ,file,folder_ids,is_change,ex_reason})

/*
 * 创建/更新任务附件文件夹
 * */
export const addTaskFolder = (id,name) => qspost('/api/Createtask/addTaskFolder', {id,name})

/*
 * 赋分/审核赋分任务
 * 不传或0 为赋分任务    1为审核赋分任务
 * */
export const getTaskScoreEx = (pid,state) => qspost('/api/Createtask/getTaskScoreEx', {pid,state})

/*
 *提交赋分审核
 * */
export const setTaskScoreEx = (pid,result) => qspost('/api/Createtask/setTaskScoreEx', {pid,result})

/*
 *任务导出接口
 * */
export const exportProDetail = (pro_id,id,start_time,end_time) => postfile('/api/Createtask/exportProDetail', {pro_id,id,start_time,end_time})


/*
 *所有非审核人员接口（制定审核人员用）
 * */
export const getNoVerifierUsers = () => qspost('/api/Audit/userAll', {})

/*
 *审核人列表
 * */
export const getVerifierUsers = (searchName) => qspost('/api/Audit/getList', {searchName})

/*
 *添加审核人接口
 * */
export const addAudit = (member_id) => qspost('/api/Audit/addAudit', {member_id})

/*
 *批量修改审核人身份权限（删除操作
 * */
export const delBatch = (ids) => qspost('/api/Audit/delBatch', {ids})

/*
 *获取项目ID、name列表
 * */
export const getProjectIdNameList = () => qspost('/api/Project/getProjectIdNameList', {})

/*
 *修改审核人项目权限接口
 * */
export const saveUserPower = (member_id,project_id) => qspost('/api/Audit/saveUserPower', {member_id,project_id})

/*
 *审核赋分
 * */
export const applyExTaskScore = (id,state,reason) => qspost('/api/Extask/ExTaskScore', {id,state,reason})

/*
 *审核任务列表
 * */
export const getExTaskList = (pid,state = 4) => qspost('/api/Extask/ExTaskList', {pid,state})

/*
 *审核任务详情
 * */
export const getExTaskDetail = (tid,id) => qspost('/api/Extask/ExTaskDetail', {tid,id})

/*
 *审核任务
 * */
export const applyExUpdateTask = (tid,id,state,reason) => qspost('/api/Extask/ExUpdateTask', {tid,id,state,reason})

/*
 *审核评审任务列表
 * */
export const getExTaskReviewList = (pid,state = 6) => qspost('/api/Extask/ExTaskReviewList', {pid,state})

/*
 *审核评审任务详情
 * */
export const getExTaskReviewDetail = (id) => qspost('/api/Extask/ExTaskReviewDetail', {id})

/*
 *我的任务列表
 * */
export const myTaskList = (state,page,limit) => qspost('/api/Task/myTaskList', {state,page,limit})

/*
 *根据任务文件夹ID获取文件列表
 * */
export const getEnclosureByFolderId = (id) => qspost('/api/Task/getEnclosureByFolderId', {id})

/*
 *上传任务附件到文件夹
 * */
export const addTaskFolderFile = (wid,file_url,file_name) => qspost('/api/Task/addTaskFolderFile', {wid,file_url,file_name})

/*
 *删除任务文件夹中的附件
 * */
export const delTaskFolderFile = (id) => qspost('/api/Task/delTaskFolderFile', {id})

/*
 *任务提交评审
 * */
export const setTaskReview = (id,finish_time,self_assessment_score,self_assessment) => qspost('/api/Task/setTaskReview', {id,finish_time,self_assessment_score,self_assessment})

/*
 *审核评审任务
 * */
export const setExUpdateTaskReview = (id,state,reason,assessment_score,assessment) => qspost('/api/Extask/ExUpdateTaskReview', {id,state,reason,assessment_score,assessment})

/*
 *提交汇报节点
 * */
export const setProjectReportNode = (id,p_name,start_time,end_time,report_node) => qspost('/api/Task/setProjectReportNode', {id,p_name,start_time,end_time,report_node})

/*
 *删除汇报节点
 * */
export const delProjectReport = (id) => qspost('/api/Task/delProjectReport', {id})

/*
 *获取汇报节点
 * */
export const getProjectReportNode = (id) => qspost('/api/Task/getProjectReportNode', {id})

/*
 *添加/编辑汇报节点
 * */
export const addProjectReport = (pid,id,r_time,content,file) => qspost('/api/Task/addProjectReport', {pid,id,r_time,content,file})

/*
 *提醒计数
 * */
export const getProjectCountInfo = (pid,id,r_time,content,file) => qspost('/api/Project/getProjectInfo', {pid,id,r_time,content,file})

/*
 *提醒列表
 * */
export const getUserProList = (pid,id,r_time,content,file) => qspost('/api/Project/getUserProList', {pid,id,r_time,content,file})

/*
 *判断项目信息是否完整
 * */
export const isExProjectDetail = (id) => qspost('/api/Project/ExProjectDetail', {id})




/*
 *项目分类列表

 * */
export const getProjectCateList = (page,limit) => qspost('/api/Projectcate/getProjectCateList', {page,limit})

/*
 *添加、修改项目分类
 * */
export const saveProjectCate = (id,name) => qspost('/api/Projectcate/saveProjectCate', {id,name})

/*
 *删除项目分类
 * */
export const delProjectCate = (id) => qspost('/api/Projectcate/delProjectCate', {id})



/*
 *单位管理列表
 * */
export const getCompanyList = (type,keyword,page,limit) => qspost('/api/Project/getCompanyList', {type,keyword,page,limit})

/*
 *单位管理列表
 * */
export const addCompany = (id,company_name,type) => qspost('/api/Project/updateCompany', {id,company_name,type})

/*
 *删除单位
 * */
export const delCompany = (id) => qspost('/api/Project/delCompany', {id})


/***
 * ---------------------------------------------------------- 项目结项 ----------------------------------------------------------
 */


/*
 * 新增项目结项
 * */
export const addProjectPost = (id,check_status,check_file) => qspost('/api/Project/addProject', {id,check_status,check_file})

/*
 * 获取总结记录/委托方意见
 * */
export const getPostSummary = (p_id,type= 1) => qspost('/api/project_ex/getComments', {p_id,type})

/*
 * 编写提交总结记录/委托方意见
 * */
export const addPostSummary = (p_id,title,content,file,type= 1) => qspost('/api/project_ex/addComment', {p_id,title,content,file,type})

/*
 * 成果列表
 * */
export const getPostOutcomeFiles = (p_id) => qspost('/api/project_ex/resultList', {p_id})

/*
 * 添加成果文件
 * 0文件1文件夹
 * */
export const addPostOutcomeFile = (p_id,parent_id,type,path,name,id = 0) => qspost('/api/project_ex/addResult', {p_id,parent_id,type,path,name,id})


/*
 * 删除成果文件
 * */
export const delPostOutcomeFile = (id) => qspost('/api/project_ex/delResult', {id})


/*
 * 项目成果汇总
 * */
export const getProjectPostOutcomeFile = (keyword,cate,file_name,page,limit) => qspost('/api/admin_project_ex/getResultList', {keyword,cate,file_name,page,limit})

/*
 * 获取组织机构内人员统计
 * */
export const getMembersData = (search_name,is_export,page,limit) => qspost('/api/Statistics/getMembersData', {search_name,is_export,page,limit})

/*
 * 参与人员统计数据
 * */
export const getProjectMembersData = (search_name,cate,is_export,page,limit) => qspost('/api/Statistics/getProjectMembersData', {search_name,cate,is_export,page,limit})



/*
 * 模板文件统计
 * */
export const getStatisticsFileNum = () => qspost('/Api/Task/statisticsFileNum', {})

/*
 * 统计本月的任务情况
 * */
export const getStatisticsTaskThisMonth = (month) => qspost('/Api/Task/statisticsTaskThisMonth', {month})

/*
 * 意见反馈
 * */
export const feedback = (phone,content,source = 9) => qspost(FW_NLINEHOST + 'home/index/feedback', {
    phone,content,source
})



/*
 * 使用说明
 * */

export const getHelpList = () => qspost('api/help/getInfo', {})


/*
 * 版本列表
 * */
export const getVersionList = (page,limit) => qspost('api/Iterative/getList', {page,limit})


/*
 * 版本详情：
 * */
export const getVersionDetail = (id) => qspost('/api/Iterative/getInfo', {id})

/*
 * 迭代通知不再提醒
 * */
export const noRemind = (id) => qspost('api/Iterative/noRemind', {id})


/*
 * 下载文件
 * */

export const downloadFiles = (pid,id,type) => qspost('api/Project/judgeSystem', {pid,id,type})

/*
 * 打包状态查询
 * */

export const getZipState = () => qspost('api/Project/getZipState', {})


/*
 * 上传图片
 * */
export const uploadFile = (params) => upload(FILE_UPLOAD_HOST, params)
